import { useQuery } from '@tanstack/react-query';
import { Link, useParams } from 'react-router-dom';

import { Badge, Card, Spinner } from '../../components/ui';
import { api } from '../../lib/api';

export function MemberDetailPage() {
  const { id } = useParams<{ id: string }>();
  const { data, isLoading } = useQuery({
    queryKey: ['member', id],
    queryFn: async () => (await api.get(`/admin/members/${id}`)).data,
    enabled: !!id,
  });

  if (isLoading) return <Spinner />;
  if (!data) return <div>Not found</div>;

  return (
    <div className="space-y-4">
      <Link to="/admin/members" className="text-sm text-ink-muted underline">
        ← Back to members
      </Link>
      <h1 className="font-display text-3xl">
        {data.firstName} {data.lastName}
      </h1>

      <Card className="p-5 space-y-2">
        <div>
          <span className="text-ink-muted">Email:</span> {data.email}
        </div>
        {data.phone && (
          <div>
            <span className="text-ink-muted">Phone:</span> {data.phone}
          </div>
        )}
        <div>
          <span className="text-ink-muted">Skill level:</span> {data.skillLevel}
        </div>
        <div className="flex items-center gap-2">
          <span className="text-ink-muted">Dues:</span>
          <Badge variant={data.duesStatus === 'PAID' ? 'success' : 'warning'}>{data.duesStatus}</Badge>
        </div>
      </Card>

      {/* TODO(section-4): registration history, payment history, notes, SMS consent toggle */}
    </div>
  );
}
